'use client';

/**
 * Global Error Boundary for Next.js App Router
 * This catches errors at the root level, but note that SSR errors
 * are handled differently - they're caught by Next.js's error handling
 * before reaching this component.
 */

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // Check if this is a devtools error
  const errorMessage = error?.message || error?.toString() || '';
  const isDevtoolsError =
    errorMessage.includes("Cannot read properties of undefined (reading 'vendor')") ||
    errorMessage.includes('next-devtools') ||
    errorMessage.includes('segment-explorer') ||
    errorMessage.includes('createTextNode is not a function') ||
    errorMessage.includes('MutationObserver is not defined') ||
    error?.digest === '409296464' ||
    error?.digest === '1679929226';

  // For devtools errors in development, try to recover
  if (isDevtoolsError && process.env.NODE_ENV === 'development') {
    // Attempt to reset and continue
    try {
      reset();
    } catch (e) {
      // If reset fails, just return null to allow normal rendering
    }
    return null;
  }

  // For other errors, show error UI
  return (
    <html>
      <body>
        <div style={{ padding: '20px', fontFamily: 'system-ui' }}>
          <h2>Something went wrong!</h2>
          <p>{errorMessage}</p>
          <button onClick={() => reset()}>Try again</button>
        </div>
      </body>
    </html>
  );
}
